import { render, staticRenderFns } from "./TheHeading.vue?vue&type=template&id=6b54830e&"
import script from "./TheHeading.vue?vue&type=script&lang=js&"
export * from "./TheHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports